import { WorkerEmploymentType } from '@types';
import { ShiftDetailData } from '../claimant-table.types';

type ShiftEmploymentFlags = Pick<ShiftDetailData, 'isFreelance' | 'isTempwork' | 'isEmployee'>;

export const isEmploymentTypeMismatch = (
  shift: ShiftEmploymentFlags,
  employmentType?: WorkerEmploymentType
): boolean => !isEmploymentTypeAllowedByShift(shift, employmentType);

const isEmploymentTypeAllowedByShift = (
  shift: ShiftEmploymentFlags,
  employmentType: WorkerEmploymentType | undefined
): boolean => {
  if (!employmentType) {
    return true;
  }
  switch (employmentType) {
    case 'FREELANCER':
      return shift.isFreelance;
    case 'TEMPWORKER':
      return shift.isTempwork;
    case 'EMPLOYEE':
      return shift.isEmployee;
    default:
      return true;
  }
};
